export const ENTITLEMENT_BLOCKER = {
  EVENT_LIMIT_REACHED: "event_limit_reached",
  MEDIA_ITEM_LIMIT_REACHED: "media_item_limit_reached",
  STORAGE_LIMIT_REACHED: "storage_limit_reached",
  FILE_TOO_LARGE: "file_too_large",
  EVENT_ALBUM_LIMIT_REACHED: "event_album_limit_reached",
  STORAGE_ADD_ON_NOT_OFFERED: "storage_add_on_not_offered",
  STORAGE_ADD_ON_LIMIT_REACHED: "storage_add_on_limit_reached",
} as const

export type EntitlementBlockerCode =
  (typeof ENTITLEMENT_BLOCKER)[keyof typeof ENTITLEMENT_BLOCKER]

export const ENTITLEMENT_BLOCKER_CODES = [
  ENTITLEMENT_BLOCKER.EVENT_LIMIT_REACHED,
  ENTITLEMENT_BLOCKER.MEDIA_ITEM_LIMIT_REACHED,
  ENTITLEMENT_BLOCKER.STORAGE_LIMIT_REACHED,
  ENTITLEMENT_BLOCKER.FILE_TOO_LARGE,
  ENTITLEMENT_BLOCKER.EVENT_ALBUM_LIMIT_REACHED,
  ENTITLEMENT_BLOCKER.STORAGE_ADD_ON_NOT_OFFERED,
  ENTITLEMENT_BLOCKER.STORAGE_ADD_ON_LIMIT_REACHED,
] as const satisfies readonly EntitlementBlockerCode[]

export const ENTITLEMENT_BLOCKER_CODE_SET = new Set<string>(
  ENTITLEMENT_BLOCKER_CODES as readonly string[],
)

export function isEntitlementBlockerCode(
  c: unknown,
): c is EntitlementBlockerCode {
  return typeof c === "string" && ENTITLEMENT_BLOCKER_CODE_SET.has(c)
}

export function entitlementBlockerDefaultUserMessage(
  code: EntitlementBlockerCode,
): string {
  switch (code) {
    case ENTITLEMENT_BLOCKER.EVENT_LIMIT_REACHED:
      return "Event limit reached. Existing events stay; new ones need an upgrade or archives."
    case ENTITLEMENT_BLOCKER.MEDIA_ITEM_LIMIT_REACHED:
      return "Media limit reached. Existing media stays; new uploads need an upgrade or removals."
    case ENTITLEMENT_BLOCKER.STORAGE_LIMIT_REACHED:
      return "You've reached your storage limit. Delete some media or upgrade to keep creating."
    case ENTITLEMENT_BLOCKER.FILE_TOO_LARGE:
      return "This file exceeds the maximum upload size."
    case ENTITLEMENT_BLOCKER.EVENT_ALBUM_LIMIT_REACHED:
      return "This event album is full."
    case ENTITLEMENT_BLOCKER.STORAGE_ADD_ON_NOT_OFFERED:
      return "Storage add-ons are not available on your plan."
    case ENTITLEMENT_BLOCKER.STORAGE_ADD_ON_LIMIT_REACHED:
      return "Maximum storage add-ons already purchased."
  }
}
